import * as React from 'react'
import { cn } from '@/lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  const isInteractive = !props.disabled && !props.readOnly

  return (
    <textarea
      data-slot='textarea'
      className={cn(
        'flex field-sizing-content min-h-16 w-full rounded-md border border-input bg-transparent px-2.5 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
        isInteractive && 'focus-visible:border-ring focus-visible:ring-ring/50',
        props.readOnly &&
          !props.disabled &&
          'cursor-default border-transparent border-b-input/40 rounded-none bg-transparent shadow-none dark:bg-transparent',
        props.disabled && 'cursor-not-allowed opacity-50',
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
